function buttonfeature() {
  $('.featureLineupContainer').each(function () {
    const title = $(this).find('.featureLineup-title');
    let titleText = title.text().trim();
    const description = $(this).find('.featureLineup-text').text().trim();

    const moreButton = $(this).find('.featureLineup-more');

    if (titleText.length > 40) {
      title.text(`${titleText.substring(0, 20)}...`);
      title.attr('title', titleText);
      titleText = `${titleText.substring(0, 45)}...`;
    } else {
      title.text(titleText);
    }
    $(this)
      .find('.featureLineupImage')
      .append(
        `<div class="featureLineup-description">
                <div class="content-card">
                  <h4>${titleText}</h4>
                  <span>${description}</span>
                </div>
              </div>`,
      );
    $(this).find('.featureLineupImage').append(moreButton);

    let imgContainer = $(this).find('.featureLineupImage');
    let headline = $(this).find('.featureLineup-headline');
    $(imgContainer).append(
      `<div class="overlay-base"><span class="card-title-base">${titleText}</span></div>`,
    );
    $(imgContainer).append(headline);
    $(this)
      .find('.featureLineupImage')
      .append(`<div class="main-title"><span class="span-title">${titleText}</span></div>`);

    $(title).remove();
    let socialContent = $(this).find('.featureLineup-buttons .featureLineup-social div').length;
    if (socialContent == 0) {
      $(this).find('.featureLineup-buttons').addClass('noSocial');
    }

    let butButton = $(this).find('.featureLineup-buynow .button').height();
    if (butButton > 22) {
      $(this).find('.featureLineup-buttons').addClass('verticalSocial');
    }
  });
}
function ticket() {
  let maxLength = 11; // Maximum text length
  let link = $(
    '#headerNav_uc_widgetContainer_ctl00_ctl00_ctl00_ctl01_ctl00_ctl01_ctl00_nl_ctl00_hlnk_buyTickets',
  );
  let text = link.text();

  if (text.length > maxLength) {
    link.text(text.slice(0, maxLength));
  }
}
$(document).ready(function () {
  // Prepend General Message Banner to Header
  $('.generalmessage').prependTo('header');
  buttonfeature();
  ticket();
});

$(window).load(function () {
  // ---
});
